import React, { useEffect, useContext, useState } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate } from 'react-router-dom';
import Draggable from 'react-draggable';
import JobService from "../Controller/JobController";
import CreateJob from "./JobForms/CreateJob";
import JobsPartList from "./JobForms/JobsPartList";
import AssetJobList from "./JobForms/AssetJobList";
import JobUserDefineFields from "./JobForms/JobUserDefineFields";
import JobsCommentList from "./JobForms/JobsCommentList";
import JobDocumentList from "./JobForms/JobDocumentList";
import JobHistoryList from "./JobForms/JobHistoryList";
import JobNotificationList from "./JobForms/JobNotificationList";
import JobRecurList from "./JobForms/JobRecurList";
import JobCostList from "./JobForms/JobCostList";
import JobReport from "./JobForms/JobReport";
import JobSignatureList from "./JobForms/JobSignatureList";
import $ from 'jquery';
import CreateJobSignature from "./JobForms/CreateJobSignature";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import HelpSite from "../../Common/HelpLink";
import CustomerHistoryListPage from "../../Customer/View/CustomerForms/CustomerHistoryList";
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
    Invoices: 22,
};
function JobsDetail({ JobID, onClose, onSuccess, CustomerID, engineersData, IsDiaries }) {
    const navigate = useNavigate();
    const { theme } = useContext(ThemeContext);
    const [isMinimized, setIsMinimized] = useState(false);
    const [jobName, setJobName] = useState("New Job");
    const [activeTab, setActiveTab] = useState('tab-jobDetail'); // Track the active tab
    const [currentJobID, setCurrentJobID] = useState(JobID); // State variable for JobID
    const [assignedModules, setAssignedModules] = useState(new Set());
    let tabClass = (currentJobID > 0) ? "nav-link" : "nav-link disabled"; // Class for disabling tabs
    const [isLock, setIsLock] = useState(0);
    const UserID = localStorage.getItem("UserID");
    const [currentClientCompanyID, setCurrentClientCompanyID] = useState(CustomerID);
    const [tabCount, setTabCount] = useState(0);
    const [phone, setPhone] = useState();
    const [mobile, setMobile] = useState();
    const [Email, setEmail] = useState();
    const [companyName, setCompany] = useState();
    const handleTabClick = () => {
        setTabCount(prevCount => prevCount + 1); // Increment the count when any tab is clicked
    };
    const changeTab = (tab) => {
        setActiveTab(tab);
        handleTabClick(); // Increment count
    };
    const toggleMinimize = () => setIsMinimized(!isMinimized);

    // Fetch Job Details
    const fetchJobDetailDetail = async (newJobID) => {
        try {
            if (newJobID > 0) {
                const jobDetail = await JobService.GetJobByID(navigate, newJobID);
                setJobName(`${jobDetail[0].CompanyName} - ${jobDetail[0].bnt_OrderNumber}`);
                setCurrentClientCompanyID(jobDetail[0].ClientCompanyID);
                setEmail(jobDetail[0].Email);
                setPhone(jobDetail[0].Telephone);
                setMobile(jobDetail[0].Mobile);
                setCompany(jobDetail[0].CompanyName);
                if (jobDetail[0].isLock === 1 && jobDetail[0].LockBy != UserID) {
                    setIsLock(1);
                }
                else {
                    setIsLock(0);
                    await JobService.LockJob(newJobID);
                }
            }
        }
        catch (error) {
            alert(error);
        }
    };

    // Set first tab active on JobID change or modal open
    useEffect(() => {

        setCurrentJobID(JobID);
        setActiveTab('tab-jobDetail');  // Set the first tab active
        if (JobID > 0) {
            fetchJobDetailDetail(JobID);
            fetchAssignedModules();


        } else {
            setJobName("New Job");
        }
    }, [JobID]);

    const handleSuccess = async () => {
        const newJobID = parseInt(localStorage.getItem('JobID'), 10);
        setCurrentJobID(newJobID);
        await fetchJobDetailDetail(newJobID);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const CompanyID = localStorage.getItem("CompanyID");
    const fetchAssignedModules = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const modules = await ModuleService.GetRoleModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };
    return (
        <div className="modal fade jobPopupModal show d-block" id="jobPopupModal" tabIndex="-1" aria-labelledby="jobPopupModalLabel" aria-hidden="true" data-backdrop="static">

            <div className={`modal-dialog ${CustomerID > 0 ? 'modal-lg' : 'modal-xl'}`}>
                <Draggable handle=".modal-header" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                    bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                    <div className="modal-content" style={{ maxHeight: "80vh", display: "flex", flexDirection: "colum" }}>
                        <div className="modal-header">
                            <h5 className="modal-title">{jobName} <strong style={{ fontSize: "14px", color: "red" }}> {isLock.toString() === "0" ? "" : "(Locked)"}</strong></h5>
                            <span>
                                <button type="button" className="close" onClick={onClose}>&times;</button>
                                <button type="button" className="close" onClick={toggleMinimize}>
                                    {isMinimized ? '+' : '-'}
                                </button>
                            </span>
                        </div>
                        {!isMinimized && (
                            <div className="modal-body" style={{ flex: "1" }}>
                                <div className="row vertical-pills-tab">
                                    <div className="d-flex justify-content-between align-items-center" style={{ marginLeft: "20px", marginRight: "25px", width: "100%", background: "#fff", borderBottom: "1px solid #d8e0e3" }}>

                                        <ul className="nav nav-tabs" style={{ border: "none", borderColor: "none" }}>
                                            <li className="nav-item">
                                                <a title='Details' style={{ background: "none", padding: "5px" }} className={`nav-link ${activeTab === 'tab-jobDetail' ? 'active' : ''}`} onClick={() => setActiveTab('tab-jobDetail')}
                                                    data-toggle="pill" href="#tab-jobDetail">
                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <img src="assets/img/resources/details.png" style={{ width: "25px", height: "25px" }} />
                                                        <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Details</strong>
                                                    </div>
                                                </a>
                                            </li>

                                            <li className="nav-item">
                                                {assignedModules.has(MODULE_IDS.Parts) && isLock.toString() === "0" ? (
                                                    <a title='Parts' style={{ background: "none", padding: "5px" }} className={`${tabClass} ${activeTab === 'tab-jobPart' ? 'active' : ''}`} onClick={() => setActiveTab('tab-jobPart')} data-toggle="pill" href="#tab-jobPart">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/jobParts.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Parts</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a title='Parts' style={{ background: "none", padding: "5px" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/jobParts.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Parts</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>

                                            <li className="nav-item">
                                                {assignedModules.has(MODULE_IDS.Assets) && isLock.toString() === "0" ? (
                                                    <a title='Assets' style={{ background: "none", padding: "5px" }} className={`${tabClass} ${activeTab === 'tab-jobAsset' ? 'active' : ''}`} onClick={() => setActiveTab('tab-jobAsset')} data-toggle="pill" href="#tab-jobAsset">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/jobAssets.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Assets</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a title='Assets' className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem", padding: "5px" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/jobAssets.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Assets</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>

                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a title='Updates' style={{ background: "none", padding: "5px" }} className={`${tabClass} ${activeTab === 'tab-jobUpdates' ? 'active' : ''}`} onClick={() => setActiveTab('tab-jobUpdates')} data-toggle="pill" href="#tab-jobUpdates">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/jobUpdates.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Updates</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a title='Updates' className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem", padding: "5px" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/jobUpdates.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Updates</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>

                                            <li className="nav-item">

                                                {isLock.toString() === "0" ? (
                                                    <a title='Documents' style={{ background: "none", padding: "5px" }} className={`${tabClass} ${activeTab === 'tab-jobDocument' ? 'active' : ''}`} onClick={() => setActiveTab('tab-jobDocument')} data-toggle="pill" href="#tab-jobDocument">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/jobDocuments.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Docu...</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a title='Documents' className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem", padding: "5px" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/jobDocuments.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Docu...</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>

                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a title='Status Log' style={{ background: "none", padding: "5px" }} className={`${tabClass} ${activeTab === 'tab-jobLog' ? 'active' : ''}`} onClick={() => setActiveTab('tab-jobLog')} data-toggle="pill" href="#tab-jobLog">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/job-status-log.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Status Log".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a title='Status Log' className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem", padding: "5px" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/job-status-log.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Status Log".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>

                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a title='Notification' style={{ background: "none", padding: "5px" }} className={`${tabClass} ${activeTab === 'tab-jobNotification' ? 'active' : ''}`} onClick={() => setActiveTab('tab-jobNotification')} data-toggle="pill" href="#tab-jobNotification">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/jobNotifications.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Notif...</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a title='Notification' className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem", padding: "5px" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/jobNotifications.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Notif...</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>

                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a title='Recur' style={{ background: "none", padding: "5px" }} className={`${tabClass} ${activeTab === 'tab-jobRecur' ? 'active' : ''}`} onClick={() => setActiveTab('tab-jobRecur')} data-toggle="pill" href="#tab-jobRecur">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/job_recurring.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Recur</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a title='Recur' className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem", padding: "5px" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/job_recurring.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Recur</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>

                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a title='Signature' style={{ background: "none", padding: "5px" }} className={`${tabClass} ${activeTab === 'tab-jobSignature' ? 'active' : ''}`} onClick={() => setActiveTab('tab-jobSignature')} data-toggle="pill" href="#tab-jobSignature">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/job_signature.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Signature</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a title='Signature' className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem", padding: "5px" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/job_signature.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Signature</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>

                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a title='Pricing' style={{ background: "none", padding: "5px" }} className={`${tabClass} ${activeTab === 'tab-jobPricing' ? 'active' : ''}`} onClick={() => setActiveTab('tab-jobPricing')} data-toggle="pill" href="#tab-jobPricing">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/job_pricing.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Pricing</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a title='Pricing' className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem", padding: "5px" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/job_pricing.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Pricing</strong>
                                                        </div>

                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-Customerhistory' ? 'active' : ''}`} data-toggle="pill" href="#tab-Customerhistory" onClick={() => changeTab('tab-Customerhistory')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/cust_comms-history.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Comms History".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/cust_comms-history.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Comms History".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>



                                        </ul>
                                        <div className="ml-auto">
                                            {activeTab === "tab-jobDetail" && (
                                                <HelpSite FormName="Job Details" Module="11" />
                                            )}
                                            {activeTab === "tab-jobPart" && (
                                                <HelpSite FormName="Parts" Module="11" />
                                            )}

                                            {activeTab === "tab-jobAsset" && (
                                                <HelpSite FormName="Assets" Module="11" />
                                            )}
                                            {activeTab === "tab-jobUser" && (
                                                <HelpSite FormName="User Define Fields" Module="11" />
                                            )}
                                            {activeTab === "tab-jobUpdates" && (
                                                <HelpSite FormName="Updates" Module="11" />
                                            )}
                                            {activeTab === "tab-jobDocument" && (
                                                <HelpSite FormName="Documents" Module="11" />
                                            )}
                                            {activeTab === "tab-jobLog" && (
                                                <HelpSite FormName="Status Log" Module="11" />
                                            )}
                                            {activeTab === "tab-jobNotification" && (
                                                <HelpSite FormName="Notification" Module="11" />
                                            )}
                                            {activeTab === "tab-jobRecur" && (
                                                <HelpSite FormName="Recur" Module="11" />
                                            )}
                                            {activeTab === "tab-jobPricing" && (
                                                <HelpSite FormName="Pricing" Module="11" />
                                            )}
                                            {activeTab === "tab-jobReports" && (
                                                <HelpSite FormName="Report" Module="3" />
                                            )}

                                        </div>


                                    </div>

                                    <div className="col-sm-12 pl-0">
                                        <div className="tab-content p-3" id="v-pills-tabContent">
                                            <div className={`tab-pane fade ${activeTab === 'tab-jobDetail' ? 'show active' : ''}`} id="tab-jobDetail">
                                                <CreateJob JobID={currentJobID} onSuccess={handleSuccess} ClientCompanyID={CustomerID} engineersData={engineersData} isLock={isLock} IsDiaries={IsDiaries} onClose={onClose} />
                                            </div>

                                            {currentJobID > 0 && assignedModules.has(MODULE_IDS.Parts) && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-jobPart' ? 'show active' : ''}`} id="tab-jobPart">
                                                    <JobsPartList JobID={currentJobID} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentJobID > 0 && assignedModules.has(MODULE_IDS.Assets) && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-jobAsset' ? 'show active' : ''}`} id="tab-jobAsset">
                                                    <AssetJobList JobID={currentJobID} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentJobID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-jobUser' ? 'show active' : ''}`} id="tab-jobUser">
                                                    <JobUserDefineFields JobID={currentJobID} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentJobID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-jobUpdates' ? 'show active' : ''}`} id="tab-jobUpdates">
                                                    <JobsCommentList JobID={currentJobID} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentJobID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-jobDocument' ? 'show active' : ''}`} id="tab-jobDocument">
                                                    <JobDocumentList JobID={currentJobID} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentJobID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-jobLog' ? 'show active' : ''}`} id="tab-jobLog">
                                                    <JobHistoryList JobID={currentJobID} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentJobID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-jobNotification' ? 'show active' : ''}`} id="tab-jobNotification">
                                                    <JobNotificationList JobID={currentJobID} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentJobID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-jobRecur' ? 'show active' : ''}`} id="tab-jobRecur">
                                                    <JobRecurList JobID={currentJobID} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentJobID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-jobPricing' ? 'show active' : ''}`} id="tab-jobPricing">
                                                    <JobCostList JobID={currentJobID} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentJobID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-jobSignature' ? 'show active' : ''}`} id="tab-jobSignature">
                                                    <JobSignatureList JobID={currentJobID} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentJobID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-jobReports' ? 'show active' : ''}`} id="tab-jobReports">
                                                    <JobReport JobID={currentJobID} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentClientCompanyID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-Customerhistory' ? 'show active' : ''}`} id="tab-Customerhistory" role="tabpanel">
                                                    <CustomerHistoryListPage ClientCompanyID={parseInt(currentClientCompanyID, 10)} IsDiaries="0" CommunicationID="0" isLock={isLock} Phone={phone} Mobile={mobile} CompanyName={companyName} ToEmail={Email} Tab={tabCount} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default JobsDetail;
